import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSCRIBE_ERROR_HANDLER } from '@xmedical/transcribe';
import { SentryTranscribeErrorHandler } from '../../core/services/sentry-transcribe-error-handler';

// Import standalone components from @xmedical/report-builder library
import {
  JumpTextRendererComponent,
  ReportControlEditorComponent,
  ReportTitleRendererComponent,
} from '@xmedical/report-builder';

/**
 * Report Renderer Module
 *
 * This module re-exports components from @xmedical/report-builder for backward
 * compatibility with existing code. New code should import the standalone
 * components directly from @xmedical/report-builder.
 */
@NgModule({
  imports: [
    CommonModule,
    // Import standalone components from library
    JumpTextRendererComponent,
    ReportControlEditorComponent,
    ReportTitleRendererComponent,
  ],
  providers: [
    { provide: TRANSCRIBE_ERROR_HANDLER, useClass: SentryTranscribeErrorHandler }
  ],
  exports: [
    // Re-export for backward compatibility
    JumpTextRendererComponent,
    ReportControlEditorComponent,
    ReportTitleRendererComponent,
  ]
})
export class ReportRendererModule {
}
